<template>
  <PlaceholderPantalla
    titulo="Configuración Financiera"
    subtitulo="Ajustes y personalización del módulo financiero"
    descripcion="Personaliza el comportamiento del módulo financiero según las necesidades de tu negocio. Configura categorías personalizadas, establece reglas de alertas, define formatos de reportes, configura integraciones bancarias automáticas y gestiona permisos de usuarios."
    :funcionalidades="funcionalidades"
    :datos-manejados="datosManejados"
    :mostrar-mockup="true"
  />
</template>

<script setup>
import PlaceholderPantalla from '../PlaceholderPantalla.vue'

const funcionalidades = [
  'Gestión de Categorías de Ingresos (crear, editar, eliminar, ordenar)',
  'Gestión de Categorías de Gastos personalizadas',
  'Configuración de Alertas: umbrales de presupuesto, vencimientos',
  'Configuración de Notificaciones por email (cuáles y a quién)',
  'Definir Tipos de Cambio por moneda',
  'Configurar Tasas de Interés por mora en cuentas por cobrar',
  'Configurar Descuentos por pronto pago automáticos',
  'Plantillas de Reportes personalizadas (guardar configuraciones)',
  'Integración con Bancos (conexión API para conciliación automática)',
  'Permisos por Usuario (quién puede ver, editar, eliminar)',
  'Configuración de Centros de Costo (opcional)',
  'Parámetros de Proyección de flujo de caja',
  'Configuración Fiscal (tasa de ISR, IVA, etc.)',
  'Prefijos y formatos de folios',
  'Respaldo y restauración de datos financieros',
  'Auditoría: Log de cambios en registros financieros'
]

const datosManejados = [
  'Catálogo de categorías de ingresos',
  'Catálogo de categorías de gastos',
  'Configuración de alertas y umbrales',
  'Destinatarios de notificaciones',
  'Tipos de cambio por moneda',
  'Tasas de interés y descuentos',
  'Plantillas de reportes guardadas',
  'Credenciales de integración bancaria',
  'Matriz de permisos por usuario',
  'Centros de costo activos',
  'Parámetros de proyección financiera',
  'Configuración fiscal del negocio',
  'Formatos y prefijos',
  'Log de auditoría de cambios'
]
</script>
